export default {
  methods: {
    removeViewport () {
      let viewportMeta = document.querySelector('#viewportMeta')
      function removeElement (_element) {
        let _parentElement = _element.parentNode
        if (_parentElement) {
          _parentElement.removeChild(_element)
        }
      }
      if (!viewportMeta) {
        return
      }
      viewportMeta && viewportMeta.remove ? viewportMeta.remove() : removeElement(viewportMeta)
    },
    initViewport () {
      let getViewportMeta = function () {
        let viewportMeta = document.querySelector('#viewportMeta')
        if (viewportMeta === null || !viewportMeta) {
          viewportMeta = document.createElement('meta')
          viewportMeta.setAttribute('id', 'viewportMeta')
          viewportMeta.setAttribute('content', '')
          let headDom = document.querySelector('head')
          headDom.appendChild(viewportMeta)
        }
        return viewportMeta
      }
      let initViewport = function (width, height) {
        let metaEl = getViewportMeta()
        let content = 'height=' + height + ',width=' + width + ',initial-scale=1.0,user-scalable=no'
        metaEl.setAttribute('name', 'viewport')
        metaEl.setAttribute('content', content)
      }
      initViewport(window.innerWidth, window.innerHeight)
    }
  }
}
